.tiles6 { grid-template-columns: repeat(6, minmax(0, 1fr)); }
.note { padding: 10px 12px; border-radius: 10px; background: var(--sub); font-size: 12px; color: var(--tx2); white-space: pre-line; }
@media (max-width: 1100px) { .tiles6 { grid-template-columns: repeat(2, minmax(0, 1fr)); } }
